import React from "react";
import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
} from "@tiny/components";
import { SuppressionView } from "@tiny/api";
import { useToggleSuppressionTypeDialog } from "./ToggleSuppressionTypeDialog.hooks";
import InfoOutline from "@tiny/icons/generated/InfoOutline";

export interface ToggleSuppressionTypeDialogProps {
  open: boolean;
  suppression: SuppressionView;
  onClose: () => void;
  onSuccess: () => void;
}

function ToggleSuppressionTypeDialog(props: ToggleSuppressionTypeDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <ToggleSuppressionTypeDialogContent {...props} />
    </Dialog>
  );
}

function ToggleSuppressionTypeDialogContent(
  props: ToggleSuppressionTypeDialogProps
) {
  const { onClose, suppression } = props;
  const { toggleSuppressionType, loading } =
    useToggleSuppressionTypeDialog(props);

  const newScope = suppression.scope === "LOCAL" ? "GLOBAL" : "LOCAL";
  const suppressionListName = suppression.name;

  return (
    <>
      <DialogTitle onClose={onClose} />
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Box
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
            style={{
              backgroundColor: "#FFFAED",
              height: 56,
              width: 56,
              borderRadius: 100,
            }}
          >
            <Typography variant="h4" color="yellow" tone={"light"}>
              <InfoOutline fontSize="large" color="inherit" />
            </Typography>
          </Box>

          <Typography
            variant="h3"
            component="div"
            color="grey"
            tone={900}
            mb={1}
          >
            Changing to {newScope.toLowerCase()} suppression?
          </Typography>
          <Typography variant="body2" color="grey" tone={800}>
            Change{" "}
            <Typography variant="body2" color="primary" tone={"main"}>
              [{suppressionListName}]
            </Typography>{" "}
            to {newScope.toLowerCase()} suppression list
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={toggleSuppressionType}
          loading={loading}
          disabled={loading}
        >
          Confirm
        </Button>
      </DialogActions>
    </>
  );
}

export default ToggleSuppressionTypeDialog;
